import { cx } from "utils/classnames";

type Props = {
  children?: string | React.ReactNode;
  className?: string;
};

export default function PageTitle({ children, className }: Props) {
  return <h2 className={cx("text-2xl font-bold", className)}>{children}</h2>;
}
